import axios from "axios";
import storage from "./storage";
import GetSensediaAuthorization from "./GetSensediaAuthorization";

const environmentName = process.env.REACT_APP_ENVIRONMENT_NAME;
const baseUrlApiAuth = process.env.REACT_APP_AUTH_BASE_PATH;
const baseUrlApi = process.env.REACT_APP_BASE_PATH;
const sensedia_client_id = process.env.REACT_APP_SENSEDIA_CLIENT_ID;
const route_prefix = process.env.REACT_APP_ROUTE_PREFIX;

storage.setEnvironmentName(environmentName);
storage.setAWSLambdaAuthBasePath(baseUrlApiAuth);
storage.setAWSLambdaBasePath(baseUrlApi);
storage.setRoutePrefix(route_prefix);

const init = axios.create({
  baseURL: baseUrlApiAuth,
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
    Authorization: `Bearer ${localStorage.getItem('app-user-api-token')}`,
    "client_id": sensedia_client_id,
    "access_token": ''
  }
});

init.interceptors.request.use(async (config) => {
  storage.setEnvironmentName(environmentName);
  storage.setAWSLambdaAuthBasePath(baseUrlApiAuth);
  storage.setAWSLambdaBasePath(baseUrlApi);
  storage.setRoutePrefix(route_prefix);

  await GetSensediaAuthorization().then((response) => {
    config.headers.Authorization = `Bearer ${localStorage.getItem('app-user-api-token')}`;
    config.headers.access_token = response;
  })

  return config;
});

const initExternal = axios.create({
  baseURL: baseUrlApiAuth,
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
    "client_id": sensedia_client_id,
    "access_token": ''
  },
});

initExternal.interceptors.request.use(async (config) => {
  storage.setEnvironmentName(environmentName);
  storage.setAWSLambdaAuthBasePath(baseUrlApiAuth);
  storage.setAWSLambdaBasePath(baseUrlApi);
  storage.setRoutePrefix(route_prefix);

  await GetSensediaAuthorization().then((response) => {
    config.headers.access_token = response;
  })

  return config;
});

const initExternalUpdatePass = axios.create({
  baseURL: baseUrlApi,
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
    "client_id": sensedia_client_id,
    "access_token": ''
  },
});

initExternalUpdatePass.interceptors.request.use(async (config) => {

  await GetSensediaAuthorization().then((response) => {
    config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
    config.headers.access_token = response;
  })

  return config;
});

const api = {
  init,
  initExternal,
  initExternalUpdatePass
}

export default api;